
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ingredientSummary",
      function () {
        return require("private-next-pages/ingredientSummary.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ingredientSummary"])
      });
    }
  